import styled, { css } from 'styled-components';

export const ThumbnailsContainer = styled.div`
    display:            flex;
    flex-direction:     column;

    @media (max-width: 768px){
        visibility:         hidden;
        display:            flex;
        flex-direction:     column;
        width:              1px;
        height:             1px!important;
    }
    
    .swiper{
        width: 100%;
    }

    .swiper-wrapper{
        height: auto;
    }

        .swiper-slide{
            max-width:                  70px;
            border-left:                3px solid;
            border-left-color:          white;
            transition:                 border-left-color 0.3s;
            ${'' /* padding-left:   5px; */}
        }

            .swiper-slide-thumb-active{
                border-left-color: #005E58!important;
            }
        
            img, div[id^="thumbnail"]{
                max-width:  70px;
                max-height: 70px;
            }
`;

export const NavigationButton = css`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: absolute;
    font-weight: bold;
    font-size: 40px;
    user-select: none;
    z-index: 2;
    height: 10%;
    width: 3%;
    top: 50%;
    transform: translateY(-100%);
`;

export const SliderContainer = styled.div`
    display:        flex; 
    overflow-x:     hidden;
    padding-left:   20px;
    position:       relative;

    @media (max-width: 768px){
        padding-left:   0px;
        padding-right:  0px;
        max-height:     100vw;
    }

    .button{
        &Prev{
            ${NavigationButton}
            margin-left: 5px;
            img{
                transform: rotate(180deg);
            }
        }
        
        &Next{
            ${NavigationButton}
            left: 99%;
            transform: translateX(-100%) translateY(-100%);
        }
    }

    .swiper-pagination-bullet-active{
        background: #005E58;
    }

    .swiper-wrapper{
        ${'' /* display: flex;
        align-items: center; */}
        .swiper-slide{
            display:            flex;
            align-items:        center;
            justify-content:    center;
            overflow:           hidden;
        }

        img, div[id^="konvaContainer"]{
            max-width:      100%;
            border:         1px solid white;
            box-sizing:     border-box;
        }
    }
`;